import { css } from "@emotion/react";

const bkashStyles = css`
  &.bkash {
    #bKashFrameWrapper {
      /* height: 100vh; */
      /* position: absolute; */
      z-index: 9999999 !important;
      /* width: 100vw; */
      /* margin-top: 0; */
      /* top: 0; */
      /* position: fixed; */
    }

    &.DARK {
      .loading-style {
        color: #d12054 !important;
      }

      .update-button {
        color: #ffffff !important;
      }

      #Path_2198 {
        fill: #ae2962 !important;
      }

      .btn-apply-code,
      .rank-btn,
      .text-play {
        color: #ffffff !important;
      }

      .game-details {
        color: #d12054 !important;
      }

      .play-btn-browse-container {
        .play-btn-browse,
        .rank-btn {
          background: #dc3771 !important;
        }
      }

      .contain-style {
        .title-md {
          color: #ffffff !important;
        }
      }

      .label-sty {
        color: #000000 !important;
      }

      .mission-reward {
        span {
          color: #000000 !important;
        }
      }

      .mission-card-title,
      .timer-text,
      .reward-sty,
      .faqCircleStyle {
        color: #000000 !important;
      }

      .mission-card-description {
        div {
          svg {
            fill: #000000 !important;
          }
        }
      }

      .list-heading {
        color: #000000 !important;
      }

      .faq-icon {
        fill: #000000 !important;
      }

      .category-link-card {
        color: #ffffff !important;
      }

      .recommended-games {
        .header-style {
          color: #000000 !important;
        }
      }

      .game-card-container {
        .game-card {
          .game-title {
            color: #ffffff !important;
          }
        }
      }

      .react-select__single-value {
        color: #ffffff !important;
      }

      .browse-games-rectangular-card-bottom {
        .participant-counter-row {
          .count {
            color: #ffffff !important;
          }
        }
      }
    }
  }
`;

export default bkashStyles;
